import { createTheme } from '@mui/material/styles';

// Extend the theme types to include our custom orderStatus colors.
declare module '@mui/material/styles' {
  interface Palette {
    orderStatus: {
      pending: { main: string; contrastText: string };
      approved: { main: string; contrastText: string };
      processing: { main: string; contrastText: string };
      shipped: { main: string; contrastText: string };
      delivered: { main: string; contrastText: string };
      canceled: { main: string; contrastText: string };
      onHold: { main: string; contrastText: string };
      rejected: { main: string; contrastText: string };
      awaitingPickup: { main: string; contrastText: string };
    };
  }
  interface PaletteOptions {
    orderStatus?: {
      pending?: { main: string; contrastText: string };
      approved?: { main: string; contrastText: string };
      processing?: { main: string; contrastText: string };
      shipped?: { main: string; contrastText: string };
      delivered?: { main: string; contrastText: string };
      canceled?: { main: string; contrastText: string };
      onHold?: { main: string; contrastText: string };
      rejected?: { main: string; contrastText: string };
      awaitingPickup?: { main: string; contrastText: string };
    };
  }
}

// Get CSS variable values from the :root
const rootStyles = getComputedStyle(document.documentElement);
const buttonBg = rootStyles.getPropertyValue('--button-bg').trim() || '#E1ECE2';
const buttonText = rootStyles.getPropertyValue('--button-text').trim() || '#333333';
const background = rootStyles.getPropertyValue('--background').trim() || '#FAFAFA';
const headerBg = rootStyles.getPropertyValue('--header-bg').trim() || '#E1ECE2';
const textColor = rootStyles.getPropertyValue('--text-color').trim() || '#4B4B4B';
const headerText = rootStyles.getPropertyValue('--header-text').trim() || '#333333';
const tableRow1 = rootStyles.getPropertyValue('--table-row-1').trim() || '#F0F8F0';
const tableRow2 = rootStyles.getPropertyValue('--table-row-2').trim() || '#F9FDF9';

const theme = createTheme({
  palette: {
    primary: {
      main: buttonBg,
      contrastText: buttonText,
    },
    background: {
      default: background,
      paper: headerBg,
    },
    text: {
      primary: textColor,
    },
    // Add your orderStatus colors here.
    orderStatus: {
      pending: { main: '#fff3cd', contrastText: '#856404' },
      approved: { main: '#d4edda', contrastText: '#155724' },
      processing: { main: '#e7f0fe', contrastText: '#1d4ed8' },
      shipped: { main: '#cce5ff', contrastText: '#004085' },
      delivered: { main: '#ccfbf1', contrastText: '#065f46' },
      canceled: { main: '#f8d7da', contrastText: '#721c24' },
      onHold: { main: '#ffeeba', contrastText: '#856404' },
      rejected: { main: '#f5c6cb', contrastText: '#721c24' },
      awaitingPickup: { main: '#fff5e5', contrastText: '#aa6700' },
    },
  },
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: tableRow1,
          },
          '&:nth-of-type(even)': {
            backgroundColor: tableRow2,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: headerBg,
          color: headerText,
          textAlign: 'center',
        },
        body: {
          textAlign: 'center',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: buttonBg,
          color: buttonText,
          '&:hover': {
            backgroundColor: '#cfdad1',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
        },
      },
    },
  },
});

export default theme;